// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"254":"add61fee","650":"b343b1f0","719":"5b74cd94"}[chunkId] + ".js";
};